<script setup lang="ts">
    import { useRouter } from 'vue-router';
    import FeatureLock from '@shared/components/FeatureLock.vue';

    const props = defineProps<{
        listId: string;
        hasContactsWriteScope: boolean;
        aclCount: number;
    }>();

    const emit = defineEmits<{
        newContact: [];
        openAcl: [];
    }>();

    const router = useRouter();
</script>

<template>
    <nav class="navbar main-navbar p-relative" role="navigation">
        <div class="container-fluid">
            <p class="navbar-title d-flex gap-xs m-auto-r">
                <RouterLink to="/Lists">{{ $Resources.ListsListHeading }}</RouterLink>
                <span class="fw-400 c-light">/</span>
                {{ $Resources.ListHeading }}
            </p>

            <ul class="list-unstyled nav navbar-nav">
                <li v-if="hasContactsWriteScope">
                    <a href="javascript:void(0)" role="button" class="btn btn-default" @click="emit('newContact')">
                        <span class="glyphicon glyphicon-user m-xxs-r"></span>
                        {{ $Resources.NewContactButton }}
                    </a>
                </li>
                <li v-if="hasContactsWriteScope">
                    <a
                        href="javascript:void(0)"
                        role="button"
                        class="btn btn-default"
                        @click="router.push({ name: 'ListImport', params: { listId: props.listId } })">
                        <span class="glyphicon glyphicon-plus m-xxs-r"></span>
                        {{ $Resources.NewImportButton }}
                    </a>
                </li>
                <FeatureLock feature="Users.Acl" :hideWhenLocked="aclCount === 0">
                    <li>
                        <a role="button" class="btn btn-default btn-flex" href="javascript:void(0)" :class="{ active: aclCount > 0 }" @click="emit('openAcl')">
                            <svg
                                v-if="aclCount === 0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                            </svg>
                            <span v-if="aclCount === 0">{{ $Resources.EditAclBtnOff }}</span>

                            <svg
                                v-if="aclCount > 0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            <span v-if="aclCount > 0">{{ $Resources.EditAclBtnOn }}</span>
                        </a>
                    </li>
                </FeatureLock>
            </ul>
        </div>
    </nav>
</template>
